import bss from './bss';
import spitch from './spitch';

export default { bss, spitch };
